import { Link } from 'react-router-dom';
import { categories, articleEntry } from '@/mocks/pt/categories';

const categoryImages: Record<string, string> = {
  shoes: 'https://readdy.ai/api/search-image?query=Pair%20of%20crisp%20white%20sneakers%20on%20textured%20grey%20concrete%20floor%20bright%20angled%20sunlight%20casting%20long%20shadow%20clean%20editorial%20product%20photography%20minimalist%20composition&width=600&height=400&seq=cat-v2-shoes-2026&orientation=landscape',
  hoodies: 'https://readdy.ai/api/search-image?query=Soft%20heather%20grey%20hoodie%20neatly%20folded%20on%20dark%20charcoal%20linen%20fabric%20surface%20dramatic%20side%20lighting%20creating%20deep%20texture%20shadows%20editorial%20fashion%20photography&width=600&height=400&seq=cat-v2-hoodies-2026&orientation=landscape',
  tshirts: 'https://readdy.ai/api/search-image?query=Bright%20white%20cotton%20tshirt%20hanging%20on%20minimalist%20wooden%20hanger%20against%20light%20oak%20wall%20soft%20morning%20light%20from%20window%20clean%20editorial%20product%20photography%20airy%20composition&width=600&height=400&seq=cat-v2-tshirts-2026&orientation=landscape',
  jackets: 'https://readdy.ai/api/search-image?query=Classic%20denim%20jacket%20displayed%20on%20invisible%20stand%20against%20seamless%20white%20background%20bright%20even%20studio%20lighting%20clean%20editorial%20product%20photography%20minimalist%20aesthetic&width=600&height=400&seq=cat-v2-jackets-2026&orientation=landscape',
  pants: 'https://readdy.ai/api/search-image?query=Beige%20chino%20pants%20neatly%20folded%20on%20warm%20terracotta%20tile%20floor%20golden%20hour%20sunlight%20streaming%20creating%20warm%20shadows%20editorial%20fashion%20photography%20artistic%20composition&width=600&height=400&seq=cat-v2-pants-2026&orientation=landscape',
  headwear: 'https://readdy.ai/api/search-image?query=Classic%20black%20baseball%20cap%20resting%20on%20white%20marble%20surface%20with%20dramatic%20veining%20soft%20diffused%20studio%20lighting%20editorial%20product%20photography%20minimalist%20elegant&width=600&height=400&seq=cat-v2-headwear-2026&orientation=landscape',
  sets: 'https://readdy.ai/api/search-image?query=Matching%20tracksuit%20set%20in%20sage%20green%20hanging%20on%20minimalist%20clothing%20rack%20against%20pastel%20beige%20wall%20soft%20natural%20lighting%20editorial%20fashion%20photography%20clean%20composition&width=600&height=400&seq=cat-v2-sets-2026&orientation=landscape',
  underwear: 'https://readdy.ai/api/search-image?query=Soft%20cotton%20underwear%20neatly%20folded%20on%20light%20cream%20linen%20fabric%20textured%20surface%20gentle%20morning%20lighting%20editorial%20product%20photography%20minimalist%20intimate%20style&width=600&height=400&seq=cat-v2-underwear-2026&orientation=landscape',
  jersey: 'https://readdy.ai/api/search-image?query=Vintage%20style%20sports%20jersey%20draped%20artistically%20on%20dark%20charcoal%20background%20dramatic%20spotlight%20effect%20editorial%20sportswear%20photography%20moody%20atmospheric%20lighting&width=600&height=400&seq=cat-v2-jersey-2026&orientation=landscape',
  accessories: 'https://readdy.ai/api/search-image?query=Stylish%20sunglasses%20gold%20watch%20and%20silver%20ring%20arranged%20on%20natural%20cork%20surface%20bright%20natural%20daylight%20editorial%20product%20photography%20warm%20minimalist%20composition&width=600&height=400&seq=cat-v2-accessories-2026&orientation=landscape',
  bags: 'https://readdy.ai/api/search-image?query=Premium%20leather%20backpack%20standing%20upright%20on%20white%20wooden%20shelf%20against%20light%20grey%20wall%20soft%20even%20studio%20lighting%20editorial%20product%20photography%20clean%20minimalist%20aesthetic&width=600&height=400&seq=cat-v2-bags-2026&orientation=landscape',
  belts: 'https://readdy.ai/api/search-image?query=Brown%20leather%20belt%20artfully%20coiled%20on%20dark%20walnut%20wood%20surface%20warm%20side%20lighting%20highlighting%20texture%20and%20stitching%20editorial%20product%20photography%20rich%20tones&width=600&height=400&seq=cat-v2-belts-2026&orientation=landscape',
  perfumes: 'https://readdy.ai/api/search-image?query=Elegant%20glass%20perfume%20bottle%20with%20golden%20liquid%20reflected%20on%20dark%20mirrored%20surface%20soft%20dramatic%20lighting%20editorial%20luxury%20product%20photography%20sophisticated%20moody&width=600&height=400&seq=cat-v2-perfumes-2026&orientation=landscape',
  other: 'https://readdy.ai/api/search-image?query=Assorted%20everyday%20carry%20items%20keychain%20wallet%20phone%20case%20and%20earbuds%20casually%20arranged%20on%20kraft%20paper%20surface%20natural%20window%20lighting%20editorial%20product%20photography%20honest%20composition&width=600&height=400&seq=cat-v2-other-2026&orientation=landscape',
};

const articleImage = 'https://readdy.ai/api/search-image?query=Laptop%20screen%20displaying%20spreadsheet%20interface%20beside%20a%20coffee%20cup%20and%20notepad%20on%20light%20wood%20desk%20morning%20sunlight%20from%20window%20editorial%20workspace%20photography%20warm%20productive%20vibe&width=600&height=400&seq=cat-v2-article-2026&orientation=landscape';

export default function CategoryGrid() {
  return (
    <section className="px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 md:mb-12 gap-3">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            Categorias Verificadas
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            Escolha seu estilo e economize
          </p>
        </div>

        {/* Grid 4x4 */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {/* Category Cards */}
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative rounded-lg overflow-hidden cursor-pointer h-52 md:h-56"
            >
              {/* Image */}
              <div className="absolute inset-0">
                <img
                  src={categoryImages[cat.id] || categoryImages.other}
                  alt={`CSSBuy ${cat.namePt} - Planilha CSSBuy`}
                  title={`CSSBuy Spreadsheet ${cat.namePt}`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/15 to-transparent"></div>
              </div>

              {/* Badge */}
              {cat.badge && (
                <span className="absolute top-3 right-3 px-2.5 py-1 text-[10px] font-semibold bg-accent-500/90 text-white rounded-full backdrop-blur-sm whitespace-nowrap">
                  {cat.badge}
                </span>
              )}

              {/* Text */}
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <h3 className="text-base md:text-lg font-bold text-white mb-1">
                  {cat.namePt}
                </h3>
                <p className="text-xs text-white/70">
                  Explorar produtos &rarr;
                </p>
              </div>
            </a>
          ))}

          {/* Article Entry Card */}
          <Link
            to={articleEntry.url}
            className="group relative rounded-lg overflow-hidden cursor-pointer h-52 md:h-56"
          >
            <div className="absolute inset-0">
              <img
                src={articleImage}
                alt="Guia CSSBuy Spreadsheet - Artigo SEO"
                title="Guia SEO CSSBuy Spreadsheet"
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-accent-900/70 via-accent-800/20 to-transparent"></div>
            </div>
            <span className="absolute top-3 right-3 px-2.5 py-1 text-[10px] font-semibold bg-white/90 text-accent-800 rounded-full backdrop-blur-sm whitespace-nowrap">
              Guia SEO
            </span>
            <div className="absolute bottom-0 left-0 right-0 p-4">
              <h3 className="text-base md:text-lg font-bold text-white mb-1">
                {articleEntry.namePt}
              </h3>
              <p className="text-xs text-white/70">
                {articleEntry.subtitlePt}
              </p>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}